import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 购买类型
 */
class BuyType extends UltMeta {
    MONTH = new Meta(1, "按月付", "monthlyFee");
    YEAR = new Meta(2, "按年付", "yearFee");
}

export const BUY_TYPE = new BuyType();
/**
 * 支付类型
 */
class PayType extends UltMeta {
    WX = new Meta(1, "微信", "icon-Group2/#1AAD19");
    ALI = new Meta(2, "支付宝", "icon-a-Alipay12/#1677FF");
}
export const PAY_TYPE = new PayType();

/**
 * 业务类型
 */
class BusinessType extends UltMeta {
    Member = new Meta(1, "会员");
    SHIP_ORDER = new Meta(2, "船运单定金");
    SHIP_INFO_SERVICE_FEE = new Meta(3, "船运信息费");
}
export const BUSINESS_TYPE = new BusinessType();

/**
 * 支付状态 平台状态 回调使用
 */
class WxAliPayState extends UltMeta {
    UNPAID = new Meta(1, "未支付");
    SUCCESS = new Meta(2, "支付成功");
    CANCELLED = new Meta(3, "已取消");
    CLOSED = new Meta(4, "已关闭");
    FINISHED = new Meta(5, "已完成");
    REFUND = new Meta(6, "转入退款");
}

export const WX_ALI_PAY_STATE = new WxAliPayState();

class MiniprogramName extends UltMeta {
    CUSTOMER = new Meta(1, "链云");
    CARRIER = new Meta(2, "链运");
}
export const MINIPROGRAM_NAME = new MiniprogramName();
